<template>
    <div>
        <div class="main-button-bar">
            <el-button type="primary" size="small" @click="createGrade">发起变更</el-button>
        </div>

        <el-table
            :data="page.records"
            stripe
            style="width: 100%"
            :height="this.$tools.mainHeight() - 84"
            class="grade-table"
        >
            <el-table-column prop="creatorName" label="创建人" width="100"></el-table-column>

            <el-table-column prop="createTime" label="创建时间" width="180">
                <template slot-scope="grade">{{ $tools.timestampToTime(grade.row.createTime)}}</template>
            </el-table-column>

            <el-table-column prop="applyMonth" label="考核月份" width="100">
                <template slot-scope="grade">{{ $tools.timestampToMonth(grade.row.applyMonth)}}</template>
            </el-table-column>

            <el-table-column prop="changeGrade" label="变动总积分" width="100"></el-table-column>

            <el-table-column label="当月业绩" width="180">
                <template slot-scope="grade">{{  $tools.parsecost(grade.row.amount)}}</template>
            </el-table-column>

            <el-table-column label="当前平均业绩" width="180">
                <template slot-scope="grade">{{  $tools.parsecost(grade.row.avgAmount)}}</template>
            </el-table-column>

            <el-table-column prop="simpleNumber" label="样板单个数" width="100"></el-table-column>

            <el-table-column label="订单个数" width="100">
                <template slot-scope="grade">{{ grade.row.orderNumber}} / {{ grade.row.bigOrderNumber}}</template>
            </el-table-column>

            <el-table-column prop="otherGrade" label="其他变动分" width="100"></el-table-column>
            <el-table-column prop="remark" label="变动原因" width="300">
                <template slot-scope="grade">
                    <el-link
                        type="primary"
                        @click="showRemark(grade.row.remark)"
                    >{{ grade.row.remark }}</el-link>
                </template>
            </el-table-column>

            <el-table-column prop="reviewerName" label="审核人" width="100"></el-table-column>

            <el-table-column prop="reviewTime" label="审核时间" width="180">
                <template slot-scope="grade">{{ $tools.timestampToTime(grade.row.reviewTime)}}</template>
            </el-table-column>

            <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="grade">
                    <el-tag type="success" v-if="grade.row.status == 'Y'">有效</el-tag>
                    <el-tag type="danger" v-if="grade.row.status == 'N'">无效</el-tag>
                    <el-tag type="wwarning" v-if="grade.row.status == 'W'">审核中</el-tag>
                    <el-tag type="danger" v-if="grade.row.status == 'F'">未通过</el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="type" label="类型" width="80">
                <template slot-scope="grade">
                    <el-tag type="info" v-if="grade.row.type == 'c'">变更</el-tag>
                    <el-tag type="success" v-if="grade.row.type == 'a'">申请</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                    <el-button
                        v-if="scope.row.status == 'W'"
                        type="text"
                        size="small"
                        @click="withdraw(scope.row.id)"
                    >撤回</el-button>

                    <el-button
                        v-if="scope.row.status == 'F' || scope.row.status == 'N'"
                        type="text"
                        size="small"
                        @click="restart(scope.row.id)"
                    >重新提交</el-button>

                    <el-button
                        v-if="scope.row.applyMonth"
                        type="text"
                        size="small"
                        @click="view(scope.row.id)"
                    >详情</el-button>

                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            small
            layout="total, prev, pager, next"
            :total="page.total"
            @current-change="list"
            :current-page.sync="page.current"
            :page-size.sync="page.size"
        ></el-pagination>

        <el-dialog class="grade-add" :visible.sync="showAddDialog" title="积分变更" width="600px" @closed="refeshRule">
            <el-form label-width="120px" :rules="rules" :model="grade" ref="gradeForm">
                <el-form-item label="考核月份" prop="applyMonth">
                    <el-date-picker
                        type="month"
                        placeholder="考核月份"
                        v-model="grade.applyMonth"
                        style="width:217px"
                        class="search-item"
                        value-format="yyyy-MM-dd"
                        @change="getChangeInfo"
                        :disabled="isView"
                    ></el-date-picker>
                </el-form-item>

                <el-form-item label="总变动积分" prop="changeGrade">
                    <el-input :value="grade.changeGrade" autocomplete="off" disabled></el-input>
                </el-form-item>

                <el-form-item label="样板单加分" prop="simpleNummber">
                    <el-row>
                        <el-col :span="12"><div class="info-left"><el-input v-model="changeGrade1" autocomplete="off" disabled></el-input></div></el-col>
                        <el-col :span="12"><div class="info-right">样板单个数{{grade.simpleNumber}}</div></el-col>
                    </el-row>
                </el-form-item>

                <el-form-item label="信保单加分1" prop="orderNummber">
                    <el-row>
                        <el-col :span="12"><div class="info-left"><el-input v-model.number="changeGrade2" autocomplete="off" disabled></el-input></div></el-col>
                        <el-col :span="12"><div class="info-right">小于5000$信保单单个数{{grade.orderNumber}}</div></el-col>
                    </el-row>
                </el-form-item>

                <el-form-item label="信保单加分2" prop="bigOrderNummber">
                    <el-row>
                        <el-col :span="12"><div class="info-left"> <el-input v-model.number="changeGrade3" autocomplete="off" disabled></el-input></div></el-col>
                        <el-col :span="12"><div class="info-right">大于5000$信保单单个数{{grade.bigOrderNumber}}</div></el-col>
                    </el-row>
                </el-form-item>

                <el-form-item label="业绩加分" prop="amount">
                    <el-row>
                        <el-col :span="12"><div class="info-left"><el-input v-model.number="changeGrade4" autocomplete="off" disabled></el-input></div></el-col>
                        <el-col :span="12"><div class="info-right">当月业绩{{$tools.parsecost(grade.amount)}} <br> 当前平均业绩 {{$tools.parsecost(grade.avgAmount)}}</div></el-col>
                    </el-row>
                </el-form-item>

                <el-form-item label="其他变动积分" prop="otherGrade">
                    <el-input v-model.number="grade.otherGrade" autocomplete="off" @input="flushchangeGrade" :disabled="isView"></el-input>
                </el-form-item>

                <el-form-item label="其他变动说明" prop="remark">
                    <el-input v-model="grade.remark" autocomplete="off" type="textarea" rows="5" :disabled="isView"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer" v-if="!isView">
                <el-button
                    type="primary"
                    size="small"
                    @click="docreateGrade"
                    class="add-grade-button"
                >保存</el-button>
            </div>
        </el-dialog>

        <el-dialog title="详情" :visible.sync="showRemakrDialog" width="500px">
            <el-input disabled type="textarea" :rows="10" v-model="remark"></el-input>
        </el-dialog>
    </div>
</template>

<script>
import UserGradeDetail from "./User-grade-detail.vue";

export default {
    components: { UserGradeDetail },
    data() {
        return {
            userId: null,
            showAddDialog: false,
            showRemakrDialog: false,
            page: { size: 10, current: 1, total: 0, records: [] },
            grade: {},
            rules: {
                applyMonth: [{ required: true, message: "请输入考核月份" }],
                otherGrade: [
                    { required: true, message: "请输入变动积分" },
                    { message: "积分必须是数字", type: "number" },
                ],

                remark: [
                    { required: true, message: "请输入变动原因" },
                    { message: "限制1000个文字", min: 1, max: 1024 },
                ],
            },
            changeGrade1: 0,
            changeGrade2: 0,
            changeGrade3: 0,
            changeGrade4: 0,
            isView: false,
        };
    },
    methods: {
        createGrade() {
            this.grade = {otherGrade: 0};
            this.changeGrade1 = 0,
            this.changeGrade2 = 0,
            this.changeGrade3 = 0,
            this.changeGrade4 = 0,
            this.showAddDialog = true;
        },
        refeshRule() {
            this.isView = false;
            this.$refs["gradeForm"].resetFields();
        },
        docreateGrade() {
            let _this = this;

            _this.$refs["gradeForm"].validate().then(function() {
                _this.$http.post(
                    ["user/grade/apply", _this.grade],
                    [
                        function () {
                            _this.showAddDialog = false;
                            _this.list(1);
                        },
                    ],
                    ".add-grade-button"
                );
            });
        },
        list(current) {
            let _this = this;

            _this.page.current = current ? current : 0;

            _this.$http.post(
                ["user/grade/pageSelf", _this.page],
                [
                    function (data) {
                        _this.page = data;
                    },
                ],
                ".grade-table"
            );
        },
        withdraw(id) {
            let _this = this;

            _this.$tConfirm.show("是否撤回申请？", function () {
                _this.$http.post(
                    ["user/grade/withdraw", { id: id }],
                    [
                        function () {
                            _this.list(1);
                        },
                    ],
                    ".grade-table"
                );
            });
        },
        showRemark(remark) {
            this.remark = remark;
            this.showRemakrDialog = true;
        },
        restart(id) {
            let _this = this;

            _this.$http.post(
                ["user/grade/get", { id: id }],
                [
                    function (data) {
                        _this.grade = {
                            applyMonth : _this.$tools.timestampToDay(data.applyMonth),
                            otherGrade: 0,
                            otherGrade : data.otherGrade,
                            remark: data.remark,
                            id: data.id
                        }

                        _this.getChangeInfo();                     
                    },
                ],
                ".grade-table"
            );
        },
        getChangeInfo() {
            let _this = this;

            _this.$http.post(
                ["user/grade/getChangeInfo", { applyMonth : _this.grade.applyMonth }],
                [
                    function (data) {
                        _this.grade.simpleNumber = data && data.simpleNumber ? data.simpleNumber : 0;
                        _this.grade.orderNumber = data && data.orderNumber ? data.orderNumber : 0;
                        _this.grade.bigOrderNumber = data && data.bigOrderNumber ? data.bigOrderNumber : 0;
                        _this.grade.amount = data && data.amount ? data.amount : 0;
                        _this.grade.avgAmount = data && data.avgAmount ? data.avgAmount : 0;

                        _this.changeGrade1 = _this.grade.simpleNumber * 0.5;
                        _this.changeGrade2 = _this.grade.orderNumber * 2;
                        _this.changeGrade3 = _this.grade.bigOrderNumber * 3;
                        _this.changeGrade4 = Math.round((_this.grade.amount - _this.grade.avgAmount) / 100000);

                        _this.flushchangeGrade();
                        _this.showAddDialog = true;
                    },
                ],
                ".grade-add"
            );
        },
        flushchangeGrade() {
            this.grade.changeGrade = this.changeGrade1 + this.changeGrade2  + this.changeGrade3 + this.changeGrade4 + this.grade.otherGrade;
        },
        view(id) {
            let _this = this;

            _this.$http.post(
                ["user/grade/get", { id: id }],
                [
                    function (data) {
                        _this.grade = {
                            applyMonth : _this.$tools.timestampToDay(data.applyMonth),
                            otherGrade: 0,
                            otherGrade : data.otherGrade,
                            remark: data.remark,
                            id: data.id
                        }

                        _this.grade.simpleNumber = data && data.simpleNumber ? data.simpleNumber : 0;
                        _this.grade.orderNumber = data && data.orderNumber ? data.orderNumber : 0;
                        _this.grade.bigOrderNumber = data && data.bigOrderNumber ? data.bigOrderNumber : 0;
                        _this.grade.amount = data && data.amount ? data.amount : 0;
                        _this.grade.avgAmount = data && data.avgAmount ? data.avgAmount : 0;

                        _this.changeGrade1 = _this.grade.simpleNumber * 0.5;
                        _this.changeGrade2 = _this.grade.orderNumber * 2;
                        _this.changeGrade3 = _this.grade.bigOrderNumber * 3;
                        _this.changeGrade4 = Math.round((_this.grade.amount - _this.grade.avgAmount) / 100000);

                        _this.flushchangeGrade();
                        _this.isView = true;
                        _this.showAddDialog = true;                    
                    },
                ],
                ".grade-table"
            );
        }
    },
    mounted() {
        this.list();
    },
};
</script>

<style lang="scss" scoped>

    .info-left {
        margin-right: 5px;
    }

    .info-right {
        color: #909399;
        font-size: 12px;
    }
</style>